<template>
  <v-app id="audit-cloud">
    <status-message></status-message>

    <router-view name="dialog"></router-view>

    <!--<loading-dialog></loading-dialog>-->

    <navigation-panel></navigation-panel>

    <menu-panel></menu-panel>

    <navigation-panel-right></navigation-panel-right>

    <v-content>
      <v-container fluid>
        <div>
          <router-view></router-view>
        </div>
      </v-container>
    </v-content>

    <v-footer inset app height="auto" style="padding-top: 36px !important">
      <v-layout justify-center row wrap>
        <v-flex xs12>
          <bottom-bar @goback="goback()" @share="share()" @like="like()"></bottom-bar>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import StatusMessage from "@/components/app/StatusMessage.vue";
import MenuPanel from "@/components/app/MenuPanel.vue";
import NavigationPanel from "@/components/app/NavigationPanel.vue";
import NavigationPanelRight from "@/components/app/NavigationPanelRight.vue";
import BottomBar from "@/components/app/BottomBar.vue";

import { mapGetters } from "vuex";
import { api as appApi } from "@/store/modules/app";

export default {
  components: {
    StatusMessage,
    MenuPanel,
    NavigationPanel,
    NavigationPanelRight,
    BottomBar
  },
  props: {
    source: String
  },
  computed: {
    ...mapGetters(appApi.namespace, [appApi.getters.getCurrentLanguage])
  },
  mounted() {
    this.$i18n.locale = this.getCurrentLanguage;
    this.moment.locale(this.$i18n.locale);
  },
  watch: {
    getCurrentLanguage(value) {
      this.$i18n.locale = value;
      this.moment.locale(this.$i18n.locale);
    }
  },
  methods: {
    share() {
      let url = document.location.href;
      navigator.share({ url: url });
    },
    like() {
      /*

       payload: {
         timestamp: "",
         user_id: "",
         object_id: "",
         url: ""
       }

       this.setFavorite(payload)

       this.unsetFavorite(payload)      
       
       */
    },
    goback() {
      this.$router.go("-1");
    }
  }
};
</script>
